<section class="main-section">
    <div class="container">
        <div class="row">
            <div class="col-md-7 col-12 order-sm-first order-last">
                <div class="work">
                    <h4 class='work-h section-h'>ОПЫТ РАБОТЫ</h4>
                    <div class="company-info">
                        <div class="name-date">
                            <h4>Государственное учреждение(ЦБ)</h4>
                            <p>01/03/2020-01/08/2020</p>
                        </div>
                        <div class="info-company">
                           <p>Осуществлял поддержку базы данных: бэкап и восстановление базы.</p>
                        </div>
                    </div>
                    <div class="company-info">
                        <div class="name-date">
                            <h4>Фриланс</h4>
                            <p>01/10/2019-01/12/2019</p>
                        </div>
                        <div class="info-company">
                            <p>Принимал участие в доработке приложений. Использовал: angular, ionic, resp api, typescript, node js, MySQL.</p>
                        </div>
                    </div>
                    <div class="company-info">
                        <div class="name-date">
                            <h4>IP-SYSTEM</h4>
                            <p>01/05/2019-01/08/2019</p>
                        </div>
                        <div class="info-company">
                            <p>Участвовал в вёрстке макетов. Использовал при вёрстке: bootstrap, jquery, sass, gulp.</p>
                        </div>
                    </div>
                </div>
                <div class="lesson">
                    <h4 class="lesson-h section-h">Образование</h4>
                    <div class="institution">
                        <h4>СКГТИ</h4>
                        <p class="date">2019-2024</p>
                        <p class="info">На данный момент получаю образование программиста.
                            Система обучения: заочная.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-5 col-12 order-sm-last order-first">
                <div class="me">
                    <h4 class="me-h section-h">НЕМНОГО О СЕБЕ</h4>
                    <div class="about">
                        <p>25 лет, мужчина, не женат, детей не имею, живу в Краснодарском крае.К командировкам не готов.</p>
                    </div>
                </div>
                <div class="skillS">
                    <h4 class="skill-h section-h">ЗНАНИЯ И НАВЫКИ</h4>
                    <div class="skill">
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>HTML</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>SASS(SCSS)</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>JQuety</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>JavaScript</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>TypeScript</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>Angular</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>Vue</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>MySQL</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="knowledge">
                            <div class="wrapper">
                                <h6>NodeJS</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="languages">
                        <div class="wrapper-language">
                            <h4 class="language-h section-h">ЯЗЫКИ</h4>
                        </div>
                        <div class="language-english">
                            <div class="wrapper">
                                <h6>Английский</h6>
                            </div>
                            <div class="star">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                <i class="fa fa-circle-thin" aria-hidden="true"></i>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</section>